import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-177" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-179" data-mp="3fyvxs9ef7bak">
          What Science Teachers Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-180" data-mp="36ypl2pqjqfcg">
          <span aria-hidden="true" data-id="element-181" data-mp="36wmp7p2pprzt">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +4,200 Teachers
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-182" data-mp="321z8icdya1vs">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-mist p-6" data-id="element-183" data-mp="2s1ymgiop57nw">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-184" data-mp="v859txg9hd2s">
                <span aria-hidden="true" data-id="element-185" data-mp="q896m0fe1poa">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-186" data-mp="h4de4p2e1u5r">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-187" data-mp="78tvv5gqytzh">
                <p className="text-xs font-bold text-ink" data-id="element-188" data-mp="79v3t12gv0cz">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-189" data-mp="c7dh13nio1qs">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-190" data-mp="14vj1dpanroq3">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}